export default __webpack_public_path__ + "img/app-page/screen2.201720e3b9669ffaf28905f8c07f4a25.png";